<template>
    <div
        class="scan-ticket-detail"
        :style="{ 'background-image': 'url(' + require(`@/public/img/${$store.state.config.skin}/bg.png`) + ')'}"
    >
    <LoadingScreen v-if="isLoadingScreen" />
    <template v-else>
        <ButtonCommon
            type="active"
            className="w100 scan-ticket-detail__button-refresh"
            value="Refresh"
            icon="refresh"
            :isLoading="isLoadingRefresh"
            @on-click-button-common="() => refreshPage()"
        />
        <LoadingScreen v-if="isLoadingRefresh" />
        <div v-else class="scan-ticket-detail__list-table">
                <div class="table">
                    <span class="table__title"> {{ getTranslatedText('ticket details') }}</span>
                    <div class="table__item">
                        <span class="table__item--text table__item--text-label">{{ getTranslatedText('purchase date') }}</span>
                        <span class="table__item--text table__item--text-value">{{ renderDate(dataDetail.created_at) }}</span>
                    </div>
                    <div class="table__item">
                        <span class="table__item--text table__item--text-label">{{ getTranslatedText('payment received') }}</span>
                        <span class="table__item--text table__item--text-value">
                            {{ dataDetail.currency_code }}
                            {{ formatPrice(dataDetail.total || dataDetail.amount) }}
                        </span>
                    </div>
                    <div class="table__item">
                        <span class="table__item--text table__item--text-label">{{ getTranslatedText('ticket') }}</span>
                        <span class="table__item--text table__item--text-value">{{ ticketId }}</span>
                    </div>
                </div>

                <template v-if="ticketType === 'L'">
                    <ItemTicketLoto v-if="$store.state.betSlip.okapiLottery" :details="dataSource.details" :events="dataSource.transaction.events" />
                    <ItemTicketLottoDaily v-else :details="dataSource.details" :events="dataSource.transaction.events" />
                </template>
                <ItemTicket v-else :dataSource="dataSource" :ticketType="ticketType" />

                <div class="table" v-if="dataDetail.cancelations > 0 && dataDetail.payout_transaction_id">
                    <span class="table__item--text">{{ getTranslatedText('Ticket is cancelled') }}</span>
                </div>
                <div class="table" v-else>
                    <span class="table__title">
                        {{
                            Boolean(dataDetail.cancelled)
                                ? getTranslatedText(dataDetail.cancelled_text || 'Ticket is canceled')
                                : getTranslatedText('winnings')
                        }}
                    </span>
                    <div v-if="isCheckShowMakePatment" class="scan-ticket-detail__table-winnings">
                        <div class="table__item">
                            <span class="table__item--text table__item--text-label">{{ getTranslatedText('make payment') }}</span>
                            <span class="table__item--text table__item--text-value big">{{ dataDetail.currency_code }} {{ renderMakePayment() }}</span>
                        </div>
                        <div class="table__button">
                            <ButtonCommon
                                type="active"
                                :isLoading="isLoadingSettle"
                                :isNoHover="true"
                                :value="isLoadingSettle ? 'processing winnings' : 'pay winnings'"
                                @on-click-button-common="settleTicket"
                            />
                        </div>
                    </div>

                    <div class="table__empty" v-if="dataDetail.winnings == 0 && dataDetail.cancelations == 0">
                        <span>{{ getTranslatedText('no winnings') }}</span>
                    </div>

                    <template v-for="(payment, paymentIndex) in payments" :key="paymentIndex">
                        <div class="table__item">
                            <span class="table__item--text table__item--text-label">{{ getTranslatedText('payment date') }}</span>
                            <span class="table__item--text table__item--text-value">{{ renderDate(payment.payment_created_at) }}</span>
                        </div>
                        <div class="table__item">
                            <span class="table__item--text table__item--text-label">{{ getTranslatedText('amount') }}</span>
                            <span class="table__item--text table__item--text-value">
                                {{ dataDetail.currency_code }}
                                {{ formatPrice(payment.payment_total) }}
                            </span>
                        </div>
                    </template>
                </div>
                <div class="table" v-if="showRaffleDetail">
                    <span class="table__title">
                        {{ getTranslatedText('Raffle Detail') }}
                    </span>

                    <div class="table__list">
                        <template v-for="(d, di) in raffleDetail" :key="di">
                            <div class="table__item">
                                <div class="table__item-content">
                                    <span class="table__item--text table__item--text-label">
                                        {{ getTranslatedText('Promotion Id') }}
                                    </span>
                                    <span class="table__item--text table__item--text-value">{{ d.promotion_id }}</span>
                                </div>
                                <div class="table__item-content">
                                    <span class="table__item--text table__item--text-label">
                                        {{ getTranslatedText('Entry Count') }}
                                    </span>
                                    <span class="table__item--text table__item--text-value">{{ d.entry_count }}</span>
                                </div>
                            </div>
                            <div class="table__item" v-if="d.no_winnings_message">
                                <span class="table__item--text table__item--text-label">
                                    {{ getTranslatedText(d.no_winnings_message) }}
                                </span>
                            </div>
                            <div class="table__item" v-for="(w, wi) in d.winnings" :key="wi">
                                <div class="table__item-content">
                                    <span class="table__item--text table__item--text-label">
                                        {{ getTranslatedText('Winning Tier') }}
                                    </span>
                                    <span class="table__item--text table__item--text-value">
                                        {{ w.tier }}
                                    </span>
                                </div>
                                <div class="table__item-content">
                                    <span class="table__item--text table__item--text-label">
                                        {{ getTranslatedText('Winning Prize') }}
                                    </span>
                                    <span class="table__item--text table__item--text-value">
                                        {{ formatPrice(w.winnings) }}
                                    </span>
                                </div>
                                <div class="table__item-content">
                                    <span v-if="w.pid" class="table__item--text table__item--text-label">
                                        {{ getTranslatedText('Paid By') }}
                                    </span>
                                    <span v-if="w.pid" class="table__item--text table__item--text-value">
                                        {{ w.paid_by }}
                                    </span>
                                </div>
                                <div class="table__item-content">
                                    <span v-if="w.pid" class="table__item--text table__item--text-label">
                                        {{ getTranslatedText('Paid At') }}
                                    </span>
                                    <span v-if="w.pid" class="table__item--text table__item--text-value">
                                        {{ renderDate(w.paid_at) }}
                                    </span>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div v-if="shouldShowSettleRaffle()" class="scan-ticket-detail__table-winnings">
                        <div class="table__item">
                            <div class="table__item-content">
                                <span class="table__item--text table__item--text-label">
                                    {{ getTranslatedText('make payment') }}
                                </span>
                                <span class="table__item--text table__item--text-value">
                                    {{ dataDetail.currency_code }}
                                    {{ formatPrice(data.transaction.unpaidRaffleAmount) }}
                                </span>
                            </div>
                        </div>
                        <div class="table__button">
                            <ButtonCommon
                                type="active"
                                :isLoading="isLoadingSettle"
                                :isNoHover="true"
                                :value="isLoadingSettle ? 'settling' : 'settle raffle'"
                                @on-click-button-common="settleRaffle"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <Dialog
            :show="dialogSettle"
            @close="closeSettle"
            @accept="onPrintSettle"
            :title="`ticket details`"
            :isShowTable="true"
            :dataTable="dataTable"
            :buttonLeftName="`close`"
            :buttonRightName="`print`"
        />
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';
import EventBus from '@/utils/EventBus';
import BetslipsService from '@/services/betslip/betslip.service.ts';
import ItemTicket from '@/components/scan/itemTicket/itemTicket.vue';
import ItemTicketLoto from '@/components/scan/itemTicket/itemLoto.vue';
import ItemTicketLottoDaily from '@/components/scan/itemTicket/itemLottoDaily.vue';
import LoadingScreen from '@/components/common/loading/loading.vue';
import ButtonCommon from '@/components/common/button/button.vue';
import Dialog from '@/components/common/dialog/dialog.vue';
import printMixins from '@/mixins/print-mixins';

export default {
    mixins: [languageMixins, utilsMixin, printMixins],
    components: { LoadingScreen, ButtonCommon, Dialog, ItemTicket, ItemTicketLoto, ItemTicketLottoDaily },
    props: {
        data: {
            type: Object,
            default: null,
        },
        ticketId: {
            type: String,
            default: '',
        },
        ticketType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isLoadingScreen: true,
            isLoadingRefresh: false,
            payments: null,
            isCheckShowMakePatment: false,
            dataDetail: null,
            printData: null,
            isLoadingSettle: false,
            showRaffleDetail: false,
            raffleDetail: false,
            dialogSettle: false,
            dataSource: null,
            dataTable: null,
        };
    },
    created() {
        this.dataSource = this.data;
        if (!this.data && this.ticketId) {
            this.onSearchTicketDetail();
        } else {
            this.fetchData();
        }
        EventBus.on('back-to-home', () => this.backToHome());
    },
    mounted() {
        document.addEventListener('resize', this.setHeight);
        this.setHeight();
    },
    unmounted() {
        EventBus.off('back-to-home');
    },
    methods: {
        setHeight() {
            const nav = document.getElementById('navigation');

            let height = nav?.clientHeight;
            height = window.innerHeight - height;

            this.height = `${height}px`;
        },

        refreshPage() {
            this.isLoadingRefresh = true;
            setTimeout(() => {
                this.isLoadingRefresh = false;
            }, 1000);
        },

        showNotification(text, type) {
            const param = {
                text: text,
                type: type,
            };
            EventBus.emit('show-notications', param);
        },

        async onSearchTicketDetail() {
            this.isLoadingScreen = true;
            try {
                const response = await BetslipsService.searchBetslip(this.ticketId);
                this.dataSource = response.data;
                this.fetchData();
            } catch (error) {
                console.log(error);
            }
        },

        // not fetching anything here actually
        fetchData() {
            let dataDetail = this.ticketType === 'L' ? this.dataSource.transaction : this.dataSource.details;
            if (this.ticketType === 'S' || this.ticketType === 'N') dataDetail['paid'] = 0;

            let isCheckWinnings =
                parseFloat(dataDetail.winnings) > 0 &&
                parseFloat(dataDetail.winnings) > parseFloat(dataDetail.paid) + parseFloat(dataDetail.payments);
            let isAbleSettle = this.ticketType === 'L' ? this.dataSource.is_able_settle : this.dataSource.details.is_able_settle;
            if (isCheckWinnings || isAbleSettle) {
                this.isCheckShowMakePatment = true;
            } else {
                this.isCheckShowMakePatment = false;
            }

            // parse raffle detail
            if(dataDetail) {
                if(dataDetail.raffle_details && dataDetail.raffle_details.length > 0) {
                    this.showRaffleDetail = true
                    this.raffleDetail = dataDetail.raffle_details
                }
            }

            // case for loto
            if (this.ticketType === 'L') {
                const payments = this.dataSource.details.filter((v) => {
                    return v.payment_total && v.payment_total > 0;
                });
                this.payments = payments;
            }

            // case for sport
            if (this.ticketType === 'S') {
                if (dataDetail.payments > 0) {
                    const payments = [
                        {
                            payment_created_at: dataDetail.paid_date,
                            payment_total: dataDetail.payments,
                        },
                    ];

                    this.payments = payments;
                }
            }

            // case for number
            if (this.ticketType === 'N') {
                if (dataDetail.payments > 0) {
                    const payments = [
                        {
                            payment_created_at: dataDetail.paid_date,
                            payment_total: dataDetail.payments,
                        },
                    ];

                    this.payments = payments;
                }
            }

            this.isLoadingScreen = false;
            this.dataDetail = dataDetail;
        },

        async settleTicket() {
            this.isLoadingSettle = true;
            try {
                const response = await BetslipsService.settleBetslip(this.ticketId);
                if (response.code === 200) {
                    this.printData = response.data;
                    this.dialogSettle = true;
                    this.isLoadingSettle = false;
                } else {
                    this.showNotification(response.message, 'error');
                    this.isLoadingSettle = false;
                }
            } catch (error) {
                console.log(error);
            }
        },

        async settleRaffle() {
            this.isLoadingSettle = true;
            try {
                const response = await BetslipsService.settleRaffle(this.data.transaction.id);
                if (response.code === 200) {
                    this.printData = response.data;
                    this.dialogSettle = true;
                    this.isLoadingSettle = false;
                } else {
                    this.showNotification(response.message, 'error');
                    this.isLoadingSettle = false;
                }
            } catch (error) {
                console.log(error);
            }
        },

        shouldShowSettleRaffle() {
            return (
                this.data.transaction.unpaidRaffleAmount > 0 &&
                this.data.transaction.cashier_is_allowed_to_pay_raffle_promotion == true
            );
        },

        onPrintSettle() {
            let isNumbers = this.ticketType === 'N' ? true : false;
            let param = this.printData;
            this.printSettle(param, isNumbers);
            this.dialogSettle = false;
            this.onSearchTicketDetail();
        },

        renderMakePayment() {
            const price =
                parseFloat(this.dataDetail.winnings) +
                parseFloat(this.dataDetail.cancelations) -
                (parseFloat(this.dataDetail.paid) + parseFloat(this.dataDetail.payments));
            return this.formatPrice(price);
        },

        backToHome() {
            EventBus.emit('off-show-ticket-detail');
        },

        closeSettle() {
            this.dialogSettle = false;
            this.onSearchTicketDetail();
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/scan/scanDetail.scss';
</style>
